var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProcessCreatePage',[_c('Header',{attrs:{"title":_vm.title}}),_c('Footer',{attrs:{"is-skippable":false,"is-back-button":true,"is-continue-button":false},on:{"backButtonClick":function($event){return _vm.$emit('previous', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }